import { render } from "./TabConsortium.vue?vue&type=template&id=758bbfc2"
import script from "./TabConsortium.vue?vue&type=script&lang=js"
export * from "./TabConsortium.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__